import { Box, Typography } from "@mui/material";
import { useEffect, useState, useMemo, useRef } from "react";
import { numeroAleatorioObtener } from "../../../../../utils/generals";
// Función para dividir las palabras en columnas

export default function DRAP_OCU_A({ exercise, isRunning, velocity }) {
  const [currentWordIndex, setCurrentWordIndex] = useState(0);
  const [allWords, setAllWords] = useState(exercise.content.split(","))
  const [columns, setColumns] = useState([[],[],[]])
  const wordsRef = useRef([])

  const minWordsPerColumn = exercise.lineas; // Mínimo de palabras por columna
  const numColumnas = parseInt(exercise.columnas);
  const numPalabras = parseInt(numColumnas * minWordsPerColumn);

  let velocidad = ((1000 / velocity) * 60);
  velocidad = velocidad - (1000 / 60);

  const splitIntoColumns = (
    words: string[],
    minWordsPerColumn: number
  ): string[][] => {
    
    const totalWords = words.length;
    const columnCount = Math.floor(totalWords / minWordsPerColumn);
    const columns: string[][] = Array.from({ length: columnCount }, () => []);
  
    words.forEach((word, index) => {
      columns[index % columnCount].push(word);
    });
  
    return columns;
  };

  const defineColumns = () => {
    const arrayPalabras = [];
    for (var i = 0; i < numPalabras; i++) {
        var al = numeroAleatorioObtener(0, allWords.length - 1);
        arrayPalabras.push(allWords[al]);
    }
    const columns = splitIntoColumns(arrayPalabras, minWordsPerColumn)
    wordsRef.current = arrayPalabras
    setColumns(columns)
  }


  useEffect(() => {
    let timer = null
    if (isRunning){
      timer = setInterval(() => {
        setCurrentWordIndex((prevIndex) => (prevIndex + 1) % (numPalabras + 1));
      }, velocidad);
    }

    return () => {
      if (timer) clearInterval(timer);
    }
  }, [wordsRef.current, isRunning]);

  useEffect(()=> {
    if (currentWordIndex == numPalabras) {
      defineColumns()
    }
  }, [currentWordIndex])

  useEffect(() =>{
    if(isRunning) defineColumns()
  }, [isRunning])

  return (
    <Box
      sx={{
        width: "100%",
        height: "auto",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        border: "1px solid #e0e0e0",
        borderRadius: "8px",
        boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
        overflow: "hidden",
        background: "#ffffff",
      }}
    >
      <Box
        sx={{
          display: "grid",
          gridTemplateColumns: `repeat(auto-fit, minmax(100px, 1fr))`,
          gap: "1%",
          width: "100%",
          height: "100%",
          maxHeight: "100%",
          overflow: "hidden",
        }}
      >
        {columns.map((column, colIndex) => (
          <Box
            key={colIndex}
            sx={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "space-between",
              height: "100%",
            }}
          >
            {column.map((word, rowIndex) => {
              const wordIndex = colIndex * minWordsPerColumn + rowIndex;
              return (
                <Typography
                  key={`${colIndex}-${rowIndex}`}
                  sx={{
                    color: currentWordIndex === wordIndex ? "#000000" : "#999",
                    padding: "3%",
                    fontSize: "clamp(0.8rem, 1.5vw, 1.5rem)",
                    lineHeight: 1.2,
                    position: "relative",
                    textAlign: "center",
                    flex: 1,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    fontWeight:
                      currentWordIndex === wordIndex ? "bold" : "normal",
                    "&::before":
                      currentWordIndex === wordIndex
                        ? {
                            content: '""',
                            fontWeight: "bold",
                            position: "absolute",
                            top: "50%",
                            left: "50%",
                            transform: "translate(-50%, -50%)",
                            width: "100%",
                            height: "100%",
                            right: "-2%",
                            bottom: 0,
                            backgroundColor: "rgba(33, 150, 243, 0.1)",
                            borderRadius: "4px",
                            zIndex: 1000000000000000000000000,
                            //transition: "all 0.3s ease-in-out",
                          }
                        : {},
                  }}
                >
                  {word}
                </Typography>
              );
            })}
          </Box>
        ))}
      </Box>
    </Box>
  );
}
